import React from 'react';
import { BasicFacet, BasicFacetValue } from '../types';

interface MarkerFacetComponentProps {
  facet: BasicFacet;
  facetKey: string;
  isExpanded: boolean;
  selectedFilters: Record<string, Set<string>>;
  onFilterChange: (facetKey: string, value: BasicFacetValue, checked: boolean, type: string | null) => void;
  sanitizeFilterValue: (value: string) => string;
  isFilterSelected: (facet: BasicFacet, value: BasicFacetValue) => boolean;
}

// Availability status mapping
const markerMap: Record<string, string> = {
  15: "Best Price",
  14: "Akcija",
  9: "Best Price",
  17: "Outlet",
  2: "Novo",
  16: "Novo",
  8: "Prednarudžba",
};

export const MarkerFacetComponent: React.FC<MarkerFacetComponentProps> = ({
  facet,
  facetKey,
  isExpanded,
  onFilterChange,
  sanitizeFilterValue,
  isFilterSelected,
}) => {
  // Filter out values that are not in the markerMap
  const filteredValues = facet.values.filter(
    (value) => markerMap[value.filter] !== undefined
  );

  if (!isExpanded) {
    return null;
  }

  return (
    <div className="ml-2 space-y-1">
      {filteredValues
        .filter((item) => [15, 9, 16, 2, 17, 8].includes(parseInt(item.filter)))
        .map((item) => {
          const sanitizedFilter = sanitizeFilterValue(item.filter);
          const label = markerMap[item.filter] || sanitizedFilter;

          return (
            <div key={item.filter} className="flex items-top">
              <input
                type="checkbox"
                id={`${facetKey}-${sanitizedFilter}`}
                checked={isFilterSelected(facet, item)}
                onChange={(e) =>
                  onFilterChange(facetKey, item, e.target.checked, facet.type)
                }
                className="mr-2 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <label
                htmlFor={`${facetKey}-${sanitizedFilter}`}
                className="text-sm text-gray-700 cursor-pointer flex items-top justify-between w-full"
              >
                <span>{label}</span>
                <span className="text-xs text-gray-500 ml-1">
                  ({item.count})
                </span>
              </label>
            </div>
          );
        })}
    </div>
  );
};
